import React, { createElement } from 'react';
import { useTheme, DefaultTheme } from 'styled-components';
import { addPxSuffix } from '@/src/helpers';
import { Icons } from './Icons';

export type Props = {
  src: Icons;
  width?: string | number;
  height?: string | number;
  margin?: string | number;
  color?: keyof DefaultTheme['colors'];
  fill?: boolean;
  style?: React.CSSProperties;
};

const Icon: React.FC<Props> = ({
  src,
  width,
  height,
  margin,
  color,
  fill,
  style,
}) => {
  const theme = useTheme();
  const icon = Icons[src];

  return createElement(icon, {
    width: width,
    height: height || width,
    color: theme.colors[color || 'black'],
    fill: fill ? 'currentColor' : 'none',
    style: {
      ...style,
      margin: addPxSuffix(margin || 0),
    },
    id: src,
  });
};

export default Icon;
